import 'url-search-params-polyfill'
import Axios from 'axios'
import app from '../constant/app_config.js'

// 通信成功時のレスポンスコード
export const ErrorCode = {
  CODE_SUCCESS: '0000000',
  CODE_ERROR_TOKEN: '9999999',
  CODE_ERROR_NETWORK: '9999999',
  CODE_INVITATION_UPPER_LIMIT: '4000151',
  CODE_INVITATION_UPPER_LIMIT_CAMPAIGN: '4000152'
}

export const ErrorMessage = {
  MSG_ERROR_TOKEN: 'アプリを終了してから、再度お試しください。',
  MSG_ERROR_NETWORK: '通信環境の良いところで、再度お試しください。'
}

export const isNonError = item => {
  return item == null || (item.title === '' && item.message === '')
}

export const nonErrorItem = () => {
  return {
    title: '',
    message: ''
  }
}

export const networkErrorItem = () => {
  return {
    title: 'エラー ' + ErrorCode.CODE_ERROR_NETWORK,
    message: ErrorMessage.MSG_ERROR_NETWORK
  }
}

export const apiErrorItem = res => {
  return {
    title: 'エラー ' + res.data.data.code,
    message: res.data.data.message
  }
}

/**
 * HTTPオブジェクト
 */
export const HTTP = accTime => {
  return Axios.create({
    baseURL: app.api.base,
    timeout: app.api.timeout,
    headers: {
      'X-API-VER': app.api.version,
      'X-API-ACC-TIME': accTime
    }
  })
}

/**
 * HTTPオブジェクトを生成する
 */
function CreateHTTP(accTime) {
  const http = HTTP(accTime)
  http.interceptors.response.use(
    response => {
      return response
    },
    error => {
      return inteceptError(error)
    }
  )
  return http
}

/**
 * Create error object
 * TODO: 多言対応
 */
function inteceptError(error) {
  console.log(error)
  switch (error.response.status) {
    case 400:
      return {
        status: 400,
        title: 'リクエストパラメータが間違っています。',
        message: 'リクエストパラメータが無い、値が空、形式がおかしい'
      }
    case 401:
      return {
        status: 401,
        title: 'Not Authorized',
        message: '認証に失敗しました。再度ログイン後お試しください。'
      }
    case 403:
      return {
        status: 403,
        title: '認証エラー',
        message: '認証に失敗しました。再度ログイン後お試しください。'
      }
    case 404:
      return {
        status: 404,
        title: 'データが見つかりません。',
        message: '該当データが見つかりませんでした。'
      }
    case 409:
      return {
        status: 409,
        title: '登録済みのユーザーです。',
        message: '入力された内容はすでに登録済みです。'
      }
    case 500:
      return {
        status: 400,
        title: 'システムエラー',
        message: 'システムエラーが発生しました。管理者にお問い合わせください。'
      }
    default:
      return { status: 999, title: '例外エラー', message: '例外発生' }
  }
}

/**
 * お知らせタブで表示するデータを取得
 * @param {String} userId
 * @param {String} clientId
 * @param {String} appToken
 */
function getInfoList(token, accTime, userId) {
  const path = '/getInfoList'
  const params = new URLSearchParams()
  params.append('client_id', app.api.clientId)
  params.append('user_id', userId)
  params.append('app_token', token)
  // const params = `client_id=${app.api.clientId}&user_id=${userId}&app_token=${token}`
  const http = CreateHTTP(accTime)
  return http.post(path, params)
}

/**
 * アカウント登録情報取得API
 * @param {String} token
 * @param {String} accTime
 * @param {String} deviceId
 */
function getRegisterInfo(token, accTime, deviceId) {
  const path = '/getRegisterInfo'
  const params = new URLSearchParams()
  console.log('****** URL search Params register info ******')
  console.log(params)
  params.append('client_id', app.api.clientId)
  params.append('device_id', deviceId)
  params.append('app_token', token)
  const http = CreateHTTP(accTime)
  return http.post(path, params)
}

/**
 * ユーザーデータ取得
 * @param {String} token
 * @param {String} accTime
 * @param {String} userId
 */
function getUserData(token, accTime, userId) {
  const path = '/getUserData'
  const params = new URLSearchParams()
  params.append('client_id', app.api.clientId)
  params.append('user_id', userId)
  params.append('app_token', token)
  const http = CreateHTTP(accTime)
  return http.post(path, params)
}

/**
 * ユーザー情報の登録
 */
function postUserData(payload, user) {
  const path = '/registerUser'
  const params = new URLSearchParams()
  // if (payload.user_id) params.append('user_id', payload.user_id)
  params.append('client_id', app.api.clientId)
  params.append('device_id', payload.device_id)
  params.append('bt_enable', payload.bt_enable)
  params.append('push_enable', payload.push_enable)
  params.append('loc_enable', payload.loc_enable)
  if (payload.invitation_uuid != null) {
    params.append('invitation_uuid', payload.invitation_uuid)
  }
  if (payload.siwa_uid) {
    params.append('siwa_uid', payload.siwa_uid)
  }
  if (payload.line_uid) {
    params.append('line_uid', payload.line_uid)
  }
  params.append('app_token', payload.app_token)

  Object.keys(user).forEach(key => {
    params.append(`register_manage_${key}`, user[key])
  })
  const http = CreateHTTP(payload.acc_time)

  console.log('post params', payload, user)
  return http.post(path, params)
}

/**
 * ユーザーデータ更新する
 * @param {*} payload
 * @param {*} user
 */
function updateUserData(payload, user) {
  console.log('call register user')
  const path = '/registerUser'
  const params = new URLSearchParams()
  params.append('user_id', payload.user_id)
  params.append('client_id', app.api.clientId)
  params.append('device_id', payload.device_id)
  params.append('bt_enable', payload.bt_enable)
  params.append('push_enable', payload.push_enable)
  params.append('loc_enable', payload.loc_enable)
  params.append('app_token', payload.app_token)

  console.log('call begin')
  Object.keys(user).forEach(key => {
    if (user[key] !== '' && user[key] !== null && user[key] !== undefined) {
      params.append(`register_manage_${key}`, user[key])
    }
  })
  console.log(params)
  console.log('call end')
  const http = CreateHTTP(payload.acc_time)
  return http.post(path, params)
}

/**
 * クーポンリストを取得
 * @param {String} payload.user_id
 * @param {String} accTime
 * @param {String} payload.app_token
 */
function getCouponList(token, accTime, userId) {
  const path = '/getCouponList'
  const params = new URLSearchParams()
  params.append('client_id', app.api.clientId)
  params.append('user_id', userId)
  params.append('app_token', token)
  const http = CreateHTTP(accTime)
  return http.post(path, params)
}

/**
 * 特典一覧を取得
 * @param {*} token
 * @param {*} accTime
 * @param {*} userId
 */
function getPrizeList(token, accTime, userId) {
  const path = '/getPrizeList'
  const params = new URLSearchParams()
  params.append('client_id', app.api.clientId)
  params.append('user_id', userId)
  params.append('app_token', token)
  const http = CreateHTTP(accTime)
  return http.post(path, params)
}

/**
 * スタンプ獲得履歴情報を取得
 * @param {*} token
 * @param {*} accTime
 * @param {*} userId
 */
function getStampHistory(token, accTime, userId) {
  const path = '/stamphistory'
  const params = new URLSearchParams()
  params.append('client_id', app.api.clientId)
  params.append('user_id', userId)
  params.append('app_token', token)
  const http = CreateHTTP(accTime)
  return http.post(path, params)
}

/**
 * クーポン詳細情報方を取得
 * @param {String} token
 * @param {String} accTime
 * @param {String} userId
 * @param {String} couponId
 */
function getCouponDetails(token, accTime, userId, couponId) {
  const path = '/getCouponDetails'
  const params = new URLSearchParams()
  params.append('client_id', app.api.clientId)
  params.append('user_id', userId)
  params.append('coupon_id', couponId)
  params.append('app_token', token)
  const http = CreateHTTP(accTime)
  return http.post(path, params)
}

/**
 * クーポン利用
 * @param {String} token
 * @param {String} accTime
 * @param {String} userId
 * @param {String} couponId
 */
function postUseCoupon(token, accTime, userId, couponId, isWeborder) {
  const path = '/useCoupon'
  const params = new URLSearchParams()
  params.append('client_id', app.api.clientId)
  params.append('user_id', userId)
  params.append('coupon_id', couponId)
  params.append('app_token', token)
  params.append('is_weborder', isWeborder ? 1 : 0)
  const http = CreateHTTP(accTime)
  return http.post(path, params)
}

/**
 * 特典利用
 * @param {String} token
 * @param {String} accTime
 * @param {String} userId
 * @param {String} prizeId
 */
function postExchangePrize(token, accTime, userId, prizeId, isWeborder) {
  const path = '/exchangePrize'
  const params = new URLSearchParams()
  params.append('client_id', app.api.clientId)
  params.append('user_id', userId)
  params.append('prize_id', prizeId)
  params.append('app_token', token)
  params.append('is_weborder', isWeborder ? 1 : 0)
  const http = CreateHTTP(accTime)
  return http.post(path, params)
}

/**
 * ユーザーデータ引き継ぎ
 * @param {String} token
 * @param {String} accTime
 * @param {String} userId
 * @param {String} password
 */
function postInheritUser(token, accTime, userId, password) {
  const path = '/inheritUser'
  const params = new URLSearchParams()
  params.append('client_id', app.api.clientId)
  params.append('user_id', userId)
  params.append('password', password)
  params.append('app_token', token)
  const http = CreateHTTP(accTime)
  return http.post(path, params)
}

/**
 * 紹介機能開始
 * @param {String} token
 * @param {String} accTime
 * @param {String} userId
 * @param {String} clientId
 * @param {String} platform
 */
function postRegisterInvitation(token, accTime, userId, clientId, platform) {
  const path = '/registerInvitation'
  const params = new URLSearchParams()
  params.append('client_id', clientId)
  params.append('user_id', userId)
  params.append('app_token', token)
  const http = CreateHTTP(accTime)
  return http.post(path, params)
}

/**
 * 紹介確認
 * @param {String} uuid
 */
function postShowInvitation(uuid) {
  const path = '/showInvitation'
  const params = new URLSearchParams()
  params.append('invitation_uuid', uuid)
  const http = CreateHTTP()
  return http.post(path, params)
}

/**
 * 招待マスタ取得
 * @param {string} token
 * @param {string} accTime
 * @param {string} userId
 * @param {string} clientId
 * @param {string} masterId
 */
function getInvitationMasterList(token, accTime, userId, clientId, masterId) {
  const path = '/getInvitationMasterList'
  const params = new URLSearchParams()
  params.append('client_id', clientId)
  params.append('user_id', userId)
  params.append('masterId', masterId)
  params.append('app_token', token)
  const http = CreateHTTP(accTime)
  return http.post(path, params)
}

function getWalkHistories(token, accTime, userId, steps) {
  const path = '/r/walk'
  const params = new URLSearchParams()
  params.append('client_id', app.api.clientId)
  params.append('user_id', userId)
  params.append('app_token', token)
  params.append('steps', steps)
  const http = CreateHTTP(accTime)
  return http.post(path, params)
}

function getSealCollection(token, accTime, userId) {
  const path = '/r/seal/collection'
  const params = new URLSearchParams()
  params.append('client_id', app.api.clientId)
  params.append('user_id', userId)
  params.append('app_token', token)
  const http = CreateHTTP(accTime)
  return http.post(path, params)
}

function getSealList(token, accTime, userId) {
  const path = '/r/seal/list'
  const params = new URLSearchParams()
  params.append('client_id', app.api.clientId)
  params.append('user_id', userId)
  params.append('app_token', token)
  const http = CreateHTTP(accTime)
  return http.post(path, params)
}

function getSeal(token, accTime, userId) {
  const path = '/r/seal'
  const params = new URLSearchParams()
  params.append('client_id', app.api.clientId)
  params.append('user_id', userId)
  params.append('app_token', token)
  const http = CreateHTTP(accTime)
  return http.post(path, params)
}

function getLoginBonus(token, accTime, userId, isAll = false) {
  const path = '/r/bonus'
  const params = new URLSearchParams()
  params.append('client_id', app.api.clientId)
  params.append('user_id', userId)
  params.append('app_token', token)
  params.append('is_all', isAll)
  const http = CreateHTTP(accTime)
  return http.post(path, params)
}

function postLineLogin(token, accTime, userId, lineAccessToken) {
  const path = '/r/line_login/regist'
  const params = new URLSearchParams()
  params.append('client_id', app.api.clientId)
  params.append('user_id', userId)
  params.append('app_token', token)
  params.append('line_access_token', lineAccessToken)
  const http = CreateHTTP(accTime)
  return http.post(path, params)
}

function postInheritUserByLineLogin(token, accTime, userId, lineAccessToken) {
  const path = '/r/line_login/inherit'
  const params = new URLSearchParams()
  params.append('client_id', app.api.clientId)
  params.append('user_id', userId)
  params.append('line_access_token', lineAccessToken)
  params.append('app_token', token)
  const http = CreateHTTP(accTime)
  return http.post(path, params)
}

function postFetchUserLine(token, accTime, userId) {
  const path = '/r/line_login/fetch'
  const params = new URLSearchParams()
  params.append('client_id', app.api.clientId)
  params.append('user_id', userId)
  params.append('app_token', token)
  const http = CreateHTTP(accTime)
  return http.post(path, params)
}

function postRevokeUserLine(token, accTime, userId) {
  const path = '/r/line_login/revoke'
  const params = new URLSearchParams()
  params.append('client_id', app.api.clientId)
  params.append('user_id', userId)
  params.append('app_token', token)
  const http = CreateHTTP(accTime)
  return http.post(path, params)
}

function postEncryptedUserId(userId, accTime) {
  const path = '/r/user/encrypted_user_id'
  const params = new URLSearchParams()
  params.append('user_id', userId)
  const http = CreateHTTP(accTime)
  return http.post(path, params)
}

function postFetchTakeOutImage(accTime) {
  const path = '/r/takeout_image/fetch'
  const params = new URLSearchParams()
  const http = CreateHTTP(accTime)
  return http.post(path, params)
}

function postFetchUserSIWA(token, accTime, userId) {
  const path = '/r/siwa/fetch'
  const params = new URLSearchParams()
  params.append('client_id', app.api.clientId)
  params.append('user_id', userId)
  params.append('app_token', token)
  const http = CreateHTTP(accTime)
  return http.post(path, params)
}

function postSIWA(token, accTime, userId, idToken, nonce) {
  const path = '/r/siwa/regist'
  const params = new URLSearchParams()
  params.append('client_id', app.api.clientId)
  params.append('user_id', userId)
  params.append('app_token', token)
  params.append('id_token', idToken)
  params.append('nonce', nonce)
  const http = CreateHTTP(accTime)
  return http.post(path, params)
}

function postRevokeUserSIWA(token, accTime, userId) {
  const path = '/r/siwa/revoke'
  const params = new URLSearchParams()
  params.append('client_id', app.api.clientId)
  params.append('user_id', userId)
  params.append('app_token', token)
  const http = CreateHTTP(accTime)
  return http.post(path, params)
}

function postInheritUserBySIWA(token, accTime, userId, idToken, nonce) {
  const path = '/r/siwa/inherit'
  const params = new URLSearchParams()
  params.append('client_id', app.api.clientId)
  params.append('user_id', userId)
  params.append('id_token', idToken)
  params.append('nonce', nonce)
  params.append('app_token', token)
  const http = CreateHTTP(accTime)
  return http.post(path, params)
}

function postAccountDelete(token, accTime, userId) {
  const path = '/deleteUser'
  const params = new URLSearchParams()
  params.append('client_id', app.api.clientId)
  params.append('user_id', userId)
  params.append('app_token', token)
  const http = CreateHTTP(accTime)
  return http.post(path, params)
}

function postRevokeSIWAToken(token, accTime, userId, idToken, nonce, authCode) {
  const path = '/r/siwa/revoke_token'
  const params = new URLSearchParams()
  params.append('client_id', app.api.clientId)
  params.append('user_id', userId)
  params.append('app_token', token)
  params.append('id_token', idToken)
  params.append('nonce', nonce)
  params.append('auth_code', authCode)
  const http = CreateHTTP(accTime)
  return http.post(path, params)
}

function postAddInviteeStamp(token, accTime, userId, invitationUUID) {
  const path = '/addInviteeStamp'
  const params = new URLSearchParams()
  params.append('client_id', app.api.clientId)
  params.append('user_id', userId)
  params.append('invitation_uuid', invitationUUID)
  params.append('app_token', token)
  const http = CreateHTTP(accTime)
  return http.post(path, params)
}

function useMultiCoupon(token, accTime, userId, couponIds, isWeborder) {
  const path = '/useMultiCoupon'
  const params = new URLSearchParams()
  params.append('client_id', app.api.clientId)
  params.append('user_id', userId)
  params.append('coupon_id', couponIds)
  params.append('app_token', token)
  params.append('is_weborder', isWeborder)
  const http = CreateHTTP(accTime)
  return http.post(path, params)
}

function postGachaList(token, accTime, userId) {
  const path = '/r/gacha/list'
  const params = new URLSearchParams()
  params.append('client_id', app.api.clientId)
  params.append('user_id', userId)
  params.append('app_token', token)
  const http = CreateHTTP(accTime)
  return http.post(path, params)
}

function postGachaPrizes(token, accTime, userId) {
  const path = '/r/gacha/prizes'
  const params = new URLSearchParams()
  params.append('client_id', app.api.clientId)
  params.append('user_id', userId)
  params.append('app_token', token)
  const http = CreateHTTP(accTime)
  return http.post(path, params)
}

function postGacha(token, accTime, userId, historyId) {
  const path = '/r/gacha'
  const params = new URLSearchParams()
  params.append('client_id', app.api.clientId)
  params.append('user_id', userId)
  params.append('app_token', token)
  params.append('history_id', historyId)
  const http = CreateHTTP(accTime)
  return http.post(path, params)
}

function postGachaNotify(token, accTime, userId) {
  const path = '/r/gacha/notify'
  const params = new URLSearchParams()
  params.append('client_id', app.api.clientId)
  params.append('user_id', userId)
  params.append('app_token', token)
  const http = CreateHTTP(accTime)
  return http.post(path, params)
}

export default {
  getInfoList,
  getRegisterInfo,
  postUserData,
  getUserData,
  updateUserData,
  getCouponList,
  getCouponDetails,
  postUseCoupon,
  postExchangePrize,
  getPrizeList,
  postInheritUser,
  postRegisterInvitation,
  postShowInvitation,
  getStampHistory,
  getInvitationMasterList,
  getWalkHistories,
  getLoginBonus,
  postLineLogin,
  postInheritUserByLineLogin,
  postFetchUserLine,
  postRevokeUserLine,
  postEncryptedUserId,
  postFetchTakeOutImage,
  postFetchUserSIWA,
  postSIWA,
  postRevokeUserSIWA,
  postInheritUserBySIWA,
  postAccountDelete,
  postRevokeSIWAToken,
  getSeal,
  getSealList,
  getSealCollection,
  postAddInviteeStamp,
  useMultiCoupon,
  postGachaList,
  postGachaPrizes,
  postGacha,
  postGachaNotify
}
